import Model from './BaseModel';

export default class RacingProducts extends Model {
	resourceName() {
		return 'products';
	}

	fields() {
		return ['display_name', 'name'];
	}

	resourceUrl() {
		return 'products/racings/';
	}
}
